import React from 'react'
import {
  Input,
  InputGroupAddon,
  InputGroup,
  InputGroupText
} from 'reactstrap';
import DatePicker from './DatePicker'

export default class TimeRangeFilter extends React.Component {
  constructor(props){
    super(props)
    this.state = {startDate: props.startDate, endDate: props.endDate, period: ''}
  }

  handleChange = () => {
    this.props.onChange(this.state.startDate,this.state.endDate)
  }


  updateStartDate = (startDate) => {
    this.setState({startDate, period: ''},this.handleChange)
  }
  updateEndDate = (endDate) => {
    this.setState({endDate, period: ''},this.handleChange)
  }
  updatePeriod = (period) => {
    const startDate = new Date()
    const endDate = new Date()
    switch (period) {
      case 'all':
        startDate.setFullYear(2000)
        break;
      case 'currentMonth':
        startDate.setDate(1)
        break;
      case 'lastMonth':
        startDate.setDate(1)
        startDate.setMonth(startDate.getMonth()-1)
        endDate.setDate(31)
        endDate.setMonth(endDate.getMonth()-1)
        break;
      case 'currentYear':
        startDate.setDate(1)
        startDate.setMonth(0)
        break;
      case 'lastYear':
        startDate.setFullYear(startDate.getFullYear()-1)
        startDate.setDate(1)
        startDate.setMonth(0)
        endDate.setFullYear(endDate.getFullYear()-1)
        endDate.setDate(31)
        endDate.setMonth(11)
        break;
      default:

    }
    this.setState({startDate, endDate, period},this.handleChange)
  }

  render(){
    return(
      <InputGroup size="sm">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>Zeitraum wählen von</InputGroupText>
        </InputGroupAddon>
        <DatePicker
          size="sm"
          value={this.state.startDate}
          onChange={(e) => this.updateStartDate(e.target.value)}
          inputStyle={{width: '100px'}}
          name="startDate"/>{' '}
        <InputGroupAddon addonType="prepend">
          <InputGroupText>bis</InputGroupText>
        </InputGroupAddon>
        <DatePicker
          size="sm"
          value={this.state.endDate}
          onChange={(e) => this.updateEndDate(e.target.value)}
          inputStyle={{width: '100px'}}
          name="endDate"/>
        <InputGroupAddon addonType="prepend">
          <InputGroupText>oder</InputGroupText>
        </InputGroupAddon>
        <Input
          type="select"
          name="period"
          value={this.state.period || ''}
          onChange={(e) => this.updatePeriod(e.target.value)}>
          <option value=""/>
          <option value="all">Alles</option>
          <option value="currentMonth">Aktueller Monat</option>
          <option value="lastMonth">Letzter Monat</option>
          <option value="currentYear">Aktuelles Jahr</option>
          <option value="lastYear">Letztes Jahr</option>
        </Input>
      </InputGroup>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/TimeRangeFilter.js